import { signal } from '@angular/core';

/**
 * Der Zustand einer Lightbox samt Fokusrueckgabe.
 *
 * <p>{@link ImageLightboxComponent} zeigt nur an; wer sie oeffnet, haelt die URL und
 * schuldet dem Auslöser den Fokus zurueck, sobald sie wieder zugeht. Dieser Vertrag
 * lag an drei Aufrufstellen je einmal und war an zweien vergessen worden — die
 * Tastaturbedienung begann dort nach dem Schliessen wieder bei <code>&lt;body&gt;</code>.
 *
 * <p>Bewusst kein Angular-Service: der Zustand gehoert genau einer Seite, und eine
 * geteilte Instanz haette zwei Lightboxen gegeneinander laufen lassen.
 */
export class LightboxController {
  private opener: HTMLElement | null = null;

  /** Die angezeigte URL; {@code null} = geschlossen. */
  readonly url = signal<string | null>(null);

  /**
   * @param fallbackFocus Ziel des Fokus, wenn der Auslöser die Seite inzwischen
   *   verlassen hat — etwa weil das Bild, das ihn trug, geloescht wurde.
   */
  constructor(private readonly fallbackFocus: () => HTMLElement | null = () => null) {}

  open(url: string, opener: HTMLElement | null = null): void {
    this.opener = opener;
    this.url.set(url);
  }

  close(): void {
    this.url.set(null);
    const opener = this.opener;
    this.opener = null;
    if (opener?.isConnected) opener.focus();
    else this.fallbackFocus()?.focus();
  }

  /** Schliesst nur, wenn gerade diese URL offen steht — etwa weil sie gerade wegfaellt. */
  closeIfShowing(url: string | null | undefined): void {
    if (url != null && this.url() === url) this.close();
  }
}
